import { useQuery } from '@tanstack/react-query';
import { IMeasure } from '../../Interfaces/ILegalTransactionMeasure';
import { customFetcher } from '../useFetch';

export const useGetMeasurements = () => {
  const { data: measurements, isLoading: isLoadingMeasurements } = useQuery<
    IMeasure[]
  >({
    queryKey: ['measurement'],
    queryFn: () => customFetcher({ endpoint: '/measurement' }),
  });

  return {
    measurements,
    isLoadingMeasurements,
  };
};
